module.exports = __webpack_public_path__ + "static/media/en.f63d4e90.png";